import React, { ChangeEvent } from "react";
import { FormField } from "../../interfaces/FormOpportunity";

import './styles.scss';

interface SelectCustomProps {
  codKey: string;
  options: any;
  value: string;
  field: FormField;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    field: FormField
  ) => void;
}

const SelectCustom: React.FC<SelectCustomProps> = ({
  codKey,
  options,
  value,
  field,
  onChange,
}) => {
  return (
    <div className="select-wrapper">
      <select
        id={codKey}
        name={codKey}
        value={value}
        onChange={(e) => onChange(e, field)}
      >
        <option value="">Selecione...</option>
        {options.map((opt:any) => (
          <option key={opt.value} value={opt.value}> {opt.label}</option>
        ))}
      </select>
    </div>
  );
};

export default SelectCustom;
